/**
 * Roter Brushstroke-Banner mit weißem Uppercase-Text.
 *
 * Umsetzung: SVG-Path mit unregelmäßigen Kanten (handgemalt-Anmutung).
 * Der Text sitzt zentriert im Path. Anton-Font kommt aus aktion.css.
 */

type Props = {
    text: string;
    /** In Prozent vom Container. */
    className?: string;
    testId?: string;
};

export default function AktionBrush({ text, className = "", testId = "aktion-brush" }: Props) {
    return (
        <div className={`inline-block relative ${className}`} data-testid={testId}>
            <svg
                viewBox="0 0 800 180"
                width="100%"
                role="img"
                aria-label={text}
                style={{ display: "block", height: "auto" }}
            >
                <defs>
                    <filter id="hf-brush-filter" x="-10%" y="-10%" width="120%" height="120%">
                        <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="1" seed="4" result="noise" />
                        <feDisplacementMap in="SourceGraphic" in2="noise" scale="4" />
                    </filter>
                </defs>
                {/* Unregelmäßiger Path — grober Pinselstrich */}
                <path
                    d="M 20 40
                       C 60 20, 130 30, 200 25
                       S 340 45, 420 30
                       S 560 15, 640 30
                       S 760 45, 782 42
                       L 785 138
                       C 720 155, 640 145, 560 152
                       S 400 138, 320 148
                       S 160 158, 90 150
                       L 22 148 Z"
                    fill="#DC2626"
                    filter="url(#hf-brush-filter)"
                />
                <text
                    x="400"
                    y="115"
                    textAnchor="middle"
                    fontFamily="Anton, 'Arial Narrow', sans-serif"
                    fontSize="90"
                    fill="#ffffff"
                    letterSpacing="2"
                    style={{ textTransform: "uppercase" }}
                >
                    {text}
                </text>
            </svg>
        </div>
    );
}
